(function()
{
	var Application = include("springroll.Application");
	var Container = include("PIXI.Container");
	var Debug = include("springroll.Debug", false);
	var DebugOptions = include("nature.DebugOptions");
	var Sprite = include("PIXI.Sprite");
	var Texture = include("PIXI.Texture");

	var DEBUG_NEVER_SHOW = false;

	var _activePanels;
	var _app;
	var _backgrounds;
	var _panelContainer;
	var _sprites;

	/**
	 * @param {} backbgrounds
	 */
	var ScrollingBackground = function(backgrounds)
	{
		Container.call(this);

		_app = Application.instance;

		// A container that we scroll
		_panelContainer = new Container();
		this.addChild(_panelContainer);
		// An object from config that controls how many times we loop each set of panels
		_backgrounds = backgrounds;
		// A library of panels that we have already loaded:
		_sprites = [];
		// The panels that make up the current backgroundSet:
		_activePanels = [];

		var len = backgrounds.length;
		for (var i = 0; i < len; i++)
		{
			var bgSet = backgrounds[i];
			//pseudo-linked list:
			bgSet.nextIdx = (i + 1) % len;
			if (bgSet.show)
			{
				this._addPanels(bgSet);
			}
		}
	};

	var s = Container.prototype;
	var p = extend(ScrollingBackground, Container);

	p.placeExtra = function()
	{
		//~szk: HACK function... QA testing found an edge case where during the end screen, if the device is rotated then there is a white background exposed. At this point, the pan would have been stopped so there is no more background management. On complete, this is called, telling the background to account for an extra 1000 pixels to the right. 
		this.pan(1000, true);
		this.pan(-1000, true);
	};

	/**
	 * @public
	 * Called from Camera
	 * @param {Number} px The pixel diff in frame updates
	 * @param {boolean} ignoreRemoval Don't remove old panels
	 */
	p.pan = function(px, ignoreRemoval)
	{
		// Right edge is between 900 and 1200 (min to max title safe area)
		var displayRightEdge = _app.display.width / _app.scaling.scale;
		// Scroll the container backwards
		_panelContainer.x -= px;

		var oldPanels = [];
		var i;
		var len;
		for (i = 0, len = _activePanels.length; i < len; i++)
		{
			var panel = _activePanels[i];
			var panelLeftEdge = _panelContainer.x + panel.x;
			var panelRightEdge = panelLeftEdge + panel.width;
			// If off screen right
			if (panelLeftEdge > displayRightEdge)
			{
				panel.visible = false;
			}
			else if (panelRightEdge < 0)
			{
				oldPanels.push(panel);
			}
			else
			{
				// Panel is on-screen
				if (!DEBUG_NEVER_SHOW) panel.visible = true;
			}
		}

		if (ignoreRemoval === true) return;
		
		for (i = 0, len = oldPanels.length; i < len; i++)
		{
			var oldPanel = oldPanels[i];
			// Panel has left us -- off screen left
			_activePanels.splice(_activePanels.indexOf(oldPanel), 1);
			_panelContainer.removeChild(oldPanel);
			oldPanel._rightEdge = null;
			// Recycle this if it still has loops
			if (oldPanel._loopCount > 0 || _app.isTutorial)
			{
				// Recycle it and make it active
				oldPanel.x = _getFarthestRightEdge();
				_activePanels.push(oldPanel);
				_panelContainer.addChild(oldPanel);
				oldPanel._loopCount--;
			}
			// If no more loops for this background set, and if we are the first, load up the next bgSet
			else if (oldPanel.isFirstInSet)
			{
				this._addPanels(_backgrounds[oldPanel.nextSetIdx]);
			}
		}
	};

	/**
	 * We add all panels into a container, and then as we scroll, we scroll the container. This way the positioning math is more straightforward
	 * @private
	 * @param {Object} bgSet Object with data for the background set
	 */
	p._addPanels = function(bgSet)
	{
		var name = bgSet.name;
		var panelCount = bgSet.panels;
		for (var i = 0; i <= panelCount; ++i)
		{
			var panel = null;
			var asset = name + "_" + i.toPaddedString(2);
			// Checking for existing panels
			for (var j = 0; j < _sprites.length; j++)
			{
				var sprite = _sprites[j];
				if (sprite.asset == asset)
				{
					panel = sprite;
					break;
				}
			}

			if (!panel)
			{
				panel = new Sprite(Texture.fromImage(asset));
				panel.asset = asset;
				_sprites.push(panel);
			}

			panel.x = _getFarthestRightEdge();
			panel.isFirstInSet = (i === 0);
			panel.nextSetIdx = bgSet.nextIdx;
			// Show this panel this many times -- will decrement as it is recycled
			panel._loopCount = DebugOptions.bgLoops ?
				DebugOptions.bgLoops - 1 :
				bgSet.loops - 1;
			// Need to explictly do this for cases when we are re-using panels:
			_panelContainer.addChild(panel);
			_activePanels.push(panel);
			if (!DEBUG_NEVER_SHOW) panel.visible = true;
		}
	};

	/**
	 * @private
	 * @return {Number} [description]
	 */
	var _getFarthestRightEdge = function()
	{
		var farthestX = 0;
		for (var i = 0; i < _activePanels.length; i++)
		{
			var panel = _activePanels[i];
			if (!panel._rightEdge)
			{
				panel._rightEdge = panel.x + panel.width;
			}
			farthestX = Math.max(farthestX, panel._rightEdge);
		}
		return farthestX;
	};

	/**
	 * @public
	 * @method destroy
	 * Don't use after this
	 */
	p.destroy = function()
	{
		if (_sprites[0].parent)
		{
			_sprites[0].parent.removeChildren();
		}
		_sprites.length = 0;
		_activePanels.length = 0;

		_panelContainer.removeChildren();
		_panelContainer.destroy(true);

		_sprites = null;
		_activePanels = null;
		_app = null;
		_backgrounds = null;
		_panelContainer = null;

		this.removeChildren();

		s.destroy.call(this, true);
	};

	namespace("nature").ScrollingBackground = ScrollingBackground;

}());